export const getTheme = () => {
  if (localStorage.theme === '"light"') {
    return "light";
  } else {
    return "dark";
  }
};
